import React, { useState, useEffect } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';

import './styles/nomina.css';
import { CardList } from './sections/CardList';
import { TableList } from './sections/TableList';
import {
  getAllRosterCards,
  getAllRosterPeriods,
} from 'app/service/nomina/Nomina';

const NominaView: React.FC = () => {
  const [secction, setSecction] = useState<'BOARD' | 'LIST'>(
    (localStorage.getItem('viewMode') as 'BOARD' | 'LIST') ?? 'LIST'
  );
  const [currentPage, setCurrentPage] = useState(1);
  // secction === "BOARD" ? 9 : 10
  const [pageSize, setPageSize] = useState(secction === 'BOARD' ? 9 : 10);
  const [totalRecordsPeriods, setTotalRecordsPeriods] = useState(0);
  const [totalRecordsCards, setTotalRecordsCards] = useState(0);

  const [rosterPeriods, setRosterPeriods] = useState<any>([]);
  const [rosterCards, setRosterCards] = useState<any>([]);

  const fetchRosterPeriods = async (page = currentPage, size = pageSize) => {
    try {
      const res = await getAllRosterPeriods(page, size);

      //Formatea con comas y puntos. 13241.43 a 13,241.43. Mejora visual
      const formattedRecords = res.records.map((record) => ({
        ...record,
        primeraNomina:
          record.primeraNomina !== null
            ? record.primeraNomina.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : null,
        complemento:
          record.complemento !== null
            ? record.complemento.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : null,
        total:
          record.total !== null
            ? record.total.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : null,
      }));
      setRosterPeriods(formattedRecords);
      setTotalRecordsPeriods(res.totalRecords);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchRosterCards = async (page = currentPage, size = pageSize) => {
    try {
      const res = await getAllRosterCards(page, size);
      setRosterCards(res.records);

      setTotalRecordsCards(res.totalRecords);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRosterPeriods(currentPage, pageSize);
    fetchRosterCards(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    setPageSize(secction === 'BOARD' ? 9 : 10);
  }, [secction]);

  const toggleMode = (mode: 'LIST' | 'BOARD') => {
    localStorage.setItem('viewMode', mode);
    setSecction(mode);
  };

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <div className="row">
            <div className="col-xxl-8 col-xl-8 col-md-8 col-lg-8">
              <ul className="nav nav-line-tabs nav-line-tabs-2x border-transparent fs-7 fw-bolder flex-nowrap">
                <li className="nav-item cursor-pointer">
                  <a
                    className={`nav-link me-6 ${
                      secction === 'LIST' ? 'text-active-primary active' : ''
                    }`}
                    onClick={() => toggleMode('LIST')}
                  >
                    <KTSVG
                      path="/media/icons/duotune/text/txt001.svg"
                      className="svg-icon-1 fs-7"
                    />
                    <span className="margin-left-05">Lista</span>
                  </a>
                </li>
                <li className="nav-item cursor-pointer">
                  <a
                    className={`nav-link me-6 ${
                      secction === 'BOARD' ? 'text-active-primary active' : ''
                    }`}
                    onClick={() => toggleMode('BOARD')}
                  >
                    <KTSVG
                      path="/media/icons/duotune/layouts/lay002.svg"
                      className="svg-icon-1 fs-7"
                    />
                    <span className="margin-left-05">Tarjetas</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            {secction === 'BOARD' && (
              <CardList
                currentPage={currentPage}
                pageSize={pageSize}
                setCurrentPage={setCurrentPage}
                board={rosterCards}
                totalRecords={totalRecordsCards}
                loadingGrid={false}
              />
            )}
            {secction === 'LIST' && (
              <TableList
                currentPage={currentPage}
                pageSize={pageSize}
                setCurrentPage={setCurrentPage}
                data={rosterPeriods}
                totalRecords={totalRecordsPeriods}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { NominaView };
